import React from 'react';
import { useIntl } from 'react-intl';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';

export const ButtonSchema = ({ intl }) => ({
  title: intl.formatMessage({ id: 'Button', defaultMessage: 'Button' }),
  fieldsets: [{ id: 'default', title: 'Default', fields: ['label', 'href'] }],
  properties: {
    label: {
      title: intl.formatMessage({ id: 'Label', defaultMessage: 'Label' }),
    },
    href: {
      title: intl.formatMessage({ id: 'Link', defaultMessage: 'Link' }),
      widget: 'object_browser',
      mode: 'link',
      allowExternals: true,
      selectedItemAttrs: ['Title'],
    },
  },
  required: ['label', 'href'],
});

export function ButtonView({ data, isEditMode = false }) {
  const intl = useIntl();
  const href = data.href?.[0]?.['@id'];
  if (!isEditMode && (!data.label?.trim() || !href)) return null;
  return (
    <div className="block bonn-button">
      {isEditMode ? (
        <span className="bonn-button-link">
          {data.label ||
            intl.formatMessage({ id: 'Button', defaultMessage: 'Button' })}
        </span>
      ) : (
        <UniversalLink href={href} className="bonn-button-link">
          {data.label}
        </UniversalLink>
      )}
    </div>
  );
}

export function ButtonEdit(props) {
  const {
    data,
    block,
    selected,
    onChangeBlock,
    blocksErrors,
    navRoot,
    contentType,
  } = props;
  const intl = useIntl();
  const schema = ButtonSchema({ intl });
  return (
    <>
      <ButtonView data={data} isEditMode />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          formData={data}
          block={block}
          onChangeField={(id, value) =>
            onChangeBlock(block, { ...data, [id]: value })
          }
          onChangeBlock={onChangeBlock}
          errors={blocksErrors}
          navRoot={navRoot}
          contentType={contentType}
        />
      </SidebarPortal>
    </>
  );
}
